<template>
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-header">
          <div class="justify-content-between d-flex align-items-center">
            <h3 class="page-title">Certificate Types</h3>
            <a @click="$emit('toBeClose', false)"
              ><i class="mdi mdi-close mdi-24px"></i
            ></a>
          </div>
        </div>
        <div class="card-body">
          <DataTable
            class="table-responsive"
            v-model:filters="filters"
            :value="certificate_types"
            stripedRows
            virtualScroller
            tableStyle="min-width: 50rem"
            responsive
            style="overflow-x: hidden"
          >
            <!-- scrollHeight="400px" -->
            <template #header> </template>
            <template #empty> No data found. </template>

            <Column header="Sr. no" headerStyle="width:3rem">
              <template #body="slotProps">
                {{ slotProps.index + 1 }}
              </template>
            </Column>

            <Column
              v-for="col of columns"
              :key="col.field"
              :field="col.field"
              :header="col.header"
              sortable
            ></Column>
            <Column field="pct_created_on" header="Uploaded On" sortable>
              <template #body="slotProps">
                {{ formatDateTime(slotProps.data.pct_created_on) }}
              </template>
            </Column>
            <Column field="pct_status" header="Status" sortable>
              <template #body="slotProps">
                <span
                  :class="[
                    slotProps.data.pct_status == 0
                      ? 'badge badge-gradient-danger'
                      : 'badge badge-gradient-success',
                  ]"
                  style="font-size: 0.875rem"
                >
                  {{ slotProps.data.pct_status == 1 ? "Active" : "Deactive" }}
                </span>
              </template>
            </Column>
            <Column header="Actions" style="width: 10%; min-width: 8rem">
              <template #body="slotProps">
                <a
                  class="btn-grid-action"
                  data-bs-toggle="Click to Download"
                  title="Edit"
                  @click="btnEditClicked(slotProps.data)"
                >
                  <i class="mdi mdi mdi-border-color mdi-24px"></i>
                </a>
                <a
                  class="btn-grid-action"
                  title="Click to Deactive"
                  @click="manageActiveStatus(slotProps.data)"
                  v-if="slotProps.data.pct_status == 1"
                >
                  <i class="mdi mdi-close-box mdi-24px"></i>
                </a>
                <a
                  class="btn-grid-action"
                  title="Click to Active"
                  @click="manageActiveStatus(slotProps.data)"
                  v-if="slotProps.data.pct_status == 0"
                >
                  <i class="mdi mdi-checkbox-marked mdi-24px"></i>
                </a>
              </template>
            </Column>
          </DataTable>
          <div class="row" style="margin-top: 1rem">
            <div class="col-md-6">
              <BInputGroup>
                <BFormInput
                  type="text"
                  class="form-control"
                  placeholder="Certificate Type"
                  v-model="pct_name"
                  :state="is_valid_certificate_type"
                />
                <BButton
                  type="submit"
                  class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"
                  @click="addUpdateCertificateType"
                  >{{ btnText }}</BButton
                >
              </BInputGroup>
              <div class="invalid-feedback" v-if="showValMsg">
                Enter Certification Type
              </div>
            </div>
            <!-- <div class="col-md-6">
              <a class="float-end" @click="fetchCertificateType()"
                >View All Certificate Type</a
              >
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="flex flex-column align-items-center p-5 surface-overlay border-round"
      >
        <div
          class="border-circle bg-gradient-primary inline-flex justify-content-center align-items-center text-white h-6rem w-6rem -mt-8"
        >
          <i
            class="mdi mdi-close-box mdi-24px"
            v-if="actionType == 'deactive'"
          ></i>
          <i
            class="mdi mdi-checkbox-marked mdi-24px"
            v-if="actionType == 'active'"
          ></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4">{{
          message.header
        }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex align-items-center gap-2 mt-4">
          <!-- <Button label="Save" @click="acceptCallback"></Button>
                    <Button label="Cancel" outlined @click="rejectCallback"></Button> -->
          <BButton
            class="btn btn-block btn-gradient-success btn-lg font-weight-medium auth-form-btn"
            @click="acceptCallback"
            >Submit
          </BButton>
          <BButton class="btn btn-light" @click="rejectCallback"
            >Cancel
          </BButton>
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script setup>
/* eslint-disable */
import { onMounted, ref } from "vue";
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import { toast } from "vue3-toastify";
import ConfirmDialog from "primevue/confirmdialog";
import { useAuthStore } from "@/store/auth_store";
import { useConfirm } from "primevue/useconfirm";
import { format } from "date-fns";
import { useLoading } from "vue-loading-overlay";

const $loading = useLoading();
const confirm = useConfirm();
const certificate_types = ref([]);
const columns = ref([
  { field: "pct_name", header: "Certificate Type" },
  { field: "pct_created_by_user", header: "Created By" },
]);
const is_valid_certificate_type = ref(null);
const filters = ref({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
});
const actionType = ref(null);
const pct_name = ref("");
const auth_store = useAuthStore();
const user = ref(null);
const btnText = ref("Add");
const objForUpdate = ref(null);

onMounted(() => {
  user.value = auth_store.logged_in_user;
  fetchCertificateType();
});

const fetchCertificateType = () => {
  const loader = $loading.show({});
  axios
    .get("/fetch_certification_types")
    .then((res) => {
      if (res.data != null) {
        loader.hide();
        certificate_types.value = [];
        certificate_types.value = res.data;
      }
    })
    .catch((err) => {
      toast(err.response.data.detail, {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
};

const manageActiveStatus = (objselectedItem) => {
  actionType.value = objselectedItem.pct_status == 1 ? "deactive" : "active";

  confirm.require({
    group: "headless",
    header: "Are you sure?",
    message:
      objselectedItem.pct_status == 1
        ? "Please confirm to deactivate the certificate type."
        : "Please confirm to activate the certificate type",
    accept: () => {
      // if (objselectedItem.pct_status == 1) objselectedItem.pct_status = 0;
      // else objselectedItem.pct_status = 1;
      const loader = $loading.show({});
      axios
        .post("/manage_certification_status", objselectedItem)
        .then((res) => {
          loader.hide();
          if (
            res.data != undefined &&
            res.data.retVal != undefined &&
            res.data.retVal != null &&
            res.data.retVal == 1
          ) {
            toast(res.data.message, {
              autoClose: 2000,
              theme: "colored",
              type: "success",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });

            fetchCertificateType();
          }
        })
        .catch((err) => {
          loader.hide();
          toast(err.response.data.detail, {
            autoClose: 2000,
            theme: "colored",
            type: "error",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        });
    },
    reject: () => {
      return;
    },
  });
};

const addUpdateCertificateType = () => {
  is_valid_certificate_type.value =
    (pct_name.value == undefined) | (pct_name.value == null) ||
    pct_name.value == ""
      ? false
      : true;

  let data = {
    pct_id: null,
    pct_name: pct_name.value,
    pct_created_on: new Date(),
    pct_created_by: user.value.user.usr_id,
    pct_status: 1,
    pct_modified_on: null,
    pct_modified_by: null,
  };

  if (objForUpdate.value != null) {
    objForUpdate.value.pct_name = pct_name.value;
    data = objForUpdate.value;
  }

  manageCertificateType(data);
};

const btnEditClicked = (objselectedItem) => {
  pct_name.value = objselectedItem.pct_name;
  btnText.value = "Update";
  objForUpdate.value = objselectedItem;
};

function manageCertificateType(data) {
  if (
    is_valid_certificate_type.value != undefined &&
    is_valid_certificate_type.value != null &&
    is_valid_certificate_type.value != ""
  ) {
    const loader = $loading.show({});
    axios
      .post("/manage_certification_type", data)
      .then((res) => {
        if (res.data != null) {
          loader.hide();
          fetchCertificateType();
          pct_name.value = "";
          objForUpdate.value = null;
          btnText.value = "Add";
          is_valid_certificate_type.value = null;
          toast("Certificate Added/Updated Successfully!", {
            autoClose: 2000,
            theme: "colored",
            type: "success",
            position: "bottom-left",
            dangerouslyHTMLString: true,
          });
        }
      })
      .catch((err) => {
        loader.hide();
        toast(err.response.data.detail, {
          autoClose: 2000,
          theme: "colored",
          type: "error",
          position: "bottom-left",
          dangerouslyHTMLString: true,
        });
      });
  } else {
    toast("Enter Certification Type", {
      autoClose: 2000,
      theme: "colored",
      type: "error",
      position: "bottom-left",
      dangerouslyHTMLString: true,
    });
    return;
  }
}

const formatDateTime = (value) => {
  if (value != null) return format(value, "MMM dd, yyyy").toLocaleString();
  return "";
};
</script>
